//@ts-check
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'

export const MAX_SUB_CATEGORIES = 10

const createEmptySubCategory = () => ({
  code: '',
  values: {},
})

export const useComboSubCategories = () => {
  const {productCombo, updateProductCombo} = useProductCombo()
  const languages = useFeatureFlagLanguages()
  const subCategories = productCombo.subCategories || []
  const isAddSubCategoryDisabled = subCategories.length >= MAX_SUB_CATEGORIES

  const handleAddSubCategory = () => {
    if (isAddSubCategoryDisabled) {
      return
    }

    updateProductCombo({
      subCategories: [...subCategories, createEmptySubCategory()],
    })
  }

  const handleRemoveSubCategory = index => {
    updateProductCombo({
      subCategories: subCategories.filter((_, subCategoryIndex) => subCategoryIndex !== index),
    })
  }

  const handleSubCategoryCodeChange = (index, value) => {
    updateProductCombo({
      subCategories: subCategories.map((subCategory, subCategoryIndex) =>
        subCategoryIndex === index ? {...subCategory, code: value} : subCategory
      ),
    })
  }

  const handleSubCategoryNameChange = (index, language, value) => {
    updateProductCombo({
      subCategories: subCategories.map((subCategory, subCategoryIndex) =>
        subCategoryIndex === index
          ? {
              ...subCategory,
              values: {
                ...subCategory.values,
                [language]: value,
              },
            }
          : subCategory
      ),
    })
  }

  return {
    languages,
    subCategories,
    isAddSubCategoryDisabled,
    handleAddSubCategory,
    handleRemoveSubCategory,
    handleSubCategoryCodeChange,
    handleSubCategoryNameChange,
  }
}
